module.exports = __webpack_public_path__ + "static/media/logo-hubspot.a2e655b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-hubspot.png
// module id = 1302
// module chunks = 17